import { TextField } from 'components'
import { useRef, useState } from 'react'
import 'react-simple-keyboard/build/css/index.css'
import Keyboard, { Props as KeyboardProps } from './Keyboard'

export interface Props extends Omit<KeyboardProps, 'open' | 'onClose'> {
  onKeyboardClose?: () => void
}

export default function TextFieldWithKeyboard({
  keyboardOptions,
  onChange,
  onClick,
  onKeyboardClose,
  value,
  label,
  ...rest
}: Props) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLInputElement>(null)

  return (
    <>
      <TextField
        ref={ref}
        borderRadius="sm"
        label={label}
        onClick={e => {
          onClick?.(e)
          e.currentTarget.blur()
          setOpen(true)
        }}
        value={value}
        onChange={e => onChange(e.target.value)}
        {...rest}
      />

      <Keyboard
        inputRef={ref.current}
        open={open}
        onClose={() => {
          setOpen(false)
          onKeyboardClose?.()
        }}
        value={value}
        onChange={onChange}
        keyboardOptions={keyboardOptions}
        {...rest}
      />
    </>
  )
}
